import * as types from './types'
import moment from 'moment'

export const mutations = {
  [types.SET_TOKENS] (state, data) {
    state.token = data.token
    state.refresh = data.refresh_token

    state.token_duration = moment().add(process.env.USER_TOKEN_DURATION, 'seconds').format()
  },
  [types.LOGIN] (state, data) {
    state.token = data.token
    state.refresh = data.refresh_token
    state.id = data.user.id
    state.user = data.user
    state.roles = data.user.roles
    state.officeId = data.user.office.id

    state.token_duration = moment().add(process.env.USER_TOKEN_DURATION, 'seconds').format()
  },
  [types.LOGOUT] (state) {
    state.user = null
    state.token = null
    state.refresh = null
    state.id = null
  },
  [types.SET_USER]  (state, data) {
    state.firstname = data.first_name
    state.lastname = data.last_name
    state.email = state.user.email
    state.address = {
      line: data.line,
      zip: data.zip,
      city: data.city,
      country: data.country
    }
    state.phone = data.phone
    state.picture = (data.media) ? process.env.ASSETS_ROOT + data.media.file : process.env.API_ROOT + '/assets/user.png'
  },
  [types.UPDATE_PROFILE]  (state, data) {
    state.firstname = data.firstname
    state.lastname = data.lastname
    state.email = data.email
    state.address = {
      line: data.address.line,
      zip: data.address.zip,
      city: data.address.city,
      country: data.address.country
    }
    state.phone = data.phone
  },
  [types.PROFIL_PICTURE] (state, data) {
    state.picture = data.image
  },
  [types.GET_ADVISORS] (state, data) {
    state.advisors = data || []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Users/mutations.js